var _path, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 67,
    viewBox: "0 0 69 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3995 14.9281C40.2658 13.7865 37.7776 13.5897 35.5105 14.3732L20.5554 18.4942C18.195 18.9858 16.1358 20.4357 14.843 22.5215C13.7329 24.7158 13.5416 27.2746 14.3078 29.6225L18.3149 45.0022C18.7929 47.4295 20.2028 49.5471 22.231 50.8766C24.3647 52.0182 26.8529 52.215 29.136 51.4271L44.0912 47.3061C46.4355 46.8189 48.5107 45.3647 49.8035 43.2788C50.8976 41.0889 51.105 38.5257 50.3388 36.1778L46.3316 20.7981C45.8376 18.3752 44.4277 16.2576 42.3995 14.9281Z",
    fill: "url(#paint0_linear_33_191)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_33_191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8492 19.2624L23.5711 22.4976C19.4802 23.6711 17.6859 26.5203 18.6926 30.2317L22.102 42.8019C23.1252 46.5741 26.0813 48.0082 30.1722 46.8347L41.4503 43.5995C45.6071 42.4071 47.3473 39.6258 46.3241 35.8536L42.9147 23.2834C41.908 19.572 39.006 18.07 34.8492 19.2624Z",
    fill: "#30AD31"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_33_191)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_33_191",
    maskUnits: "userSpaceOnUse",
    x: 22.9265,
    y: 21.9023,
    width: 39,
    height: 40,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 22.9265,
    y: 21.9023,
    width: 39,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.459 25.4971C55.5311 23.6812 52.9725 22.7547 50.3779 22.9215H33.5489C30.9362 22.7547 28.3776 23.6812 26.4497 25.4971C24.6839 27.4798 23.783 30.111 23.9452 32.7978V50.1045C23.783 52.7913 24.6839 55.4225 26.4497 57.4052C28.3776 59.2211 30.9362 60.1476 33.5489 59.9808H50.3779C52.9725 60.1476 55.5491 59.2211 57.477 57.4052C59.2248 55.4225 60.1437 52.7913 59.9816 50.1045V32.7978C60.1257 30.111 59.2248 27.4798 57.459 25.4971Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.459 25.4971C55.5311 23.6812 52.9725 22.7547 50.3779 22.9215H33.5489C30.9362 22.7547 28.3776 23.6812 26.4497 25.4971C24.6839 27.4798 23.783 30.111 23.9452 32.7978V50.1045C23.783 52.7913 24.6839 55.4225 26.4497 57.4052C28.3776 59.2211 30.9362 60.1476 33.5489 59.9808H50.3779C52.9725 60.1476 55.5491 59.2211 57.477 57.4052C59.2248 55.4225 60.1437 52.7913 59.9816 50.1045V32.7978C60.1257 30.111 59.2248 27.4798 57.459 25.4971Z",
    fill: "#72DC60",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7734 26.2251C57.1754 26.6037 57.8083 26.5848 58.1869 26.1828C58.5656 25.7807 58.5467 25.1479 58.1446 24.7692L56.7734 26.2251ZM50.3779 22.9215V23.9215C50.3993 23.9215 50.4206 23.9208 50.442 23.9195L50.3779 22.9215ZM33.5489 22.9215L33.4852 23.9195C33.5064 23.9208 33.5276 23.9215 33.5489 23.9215V22.9215ZM26.4497 25.4971L25.764 24.7692C25.7428 24.7892 25.7224 24.8102 25.7029 24.8321L26.4497 25.4971ZM23.9452 32.7978H24.9452C24.9452 32.7777 24.9445 32.7576 24.9433 32.7376L23.9452 32.7978ZM23.9452 50.1045L24.9433 50.1648C24.9445 50.1447 24.9452 50.1246 24.9452 50.1045H23.9452ZM26.4497 57.4052L25.7029 58.0703C25.7224 58.0921 25.7428 58.1131 25.764 58.1332L26.4497 57.4052ZM33.5489 59.9808V58.9808C33.5276 58.9808 33.5064 58.9815 33.4852 58.9829L33.5489 59.9808ZM50.3779 59.9808L50.442 58.9829C50.4206 58.9815 50.3993 58.9808 50.3779 58.9808V59.9808ZM57.477 57.4052L58.1627 58.1332C58.1852 58.1119 58.2067 58.0897 58.2272 58.0665L57.477 57.4052ZM59.9816 50.1045H58.9816C58.9816 50.1246 58.9822 50.1447 58.9834 50.1648L59.9816 50.1045ZM59.9816 32.7978L58.983 32.7443C58.982 32.7621 58.9816 32.78 58.9816 32.7978H59.9816ZM58.2058 24.8321C57.8385 24.4196 57.2064 24.3831 56.7939 24.7504C56.3815 25.1177 56.3449 25.7498 56.7122 26.1622L58.2058 24.8321ZM58.1446 24.7692C56.018 22.7661 53.189 21.7388 50.3137 21.9236L50.442 23.9195C52.756 23.7707 55.0441 24.5963 56.7734 26.2251L58.1446 24.7692ZM50.3779 21.9215H33.5489V23.9215H50.3779V21.9215ZM33.6126 21.9235C30.7206 21.739 27.8915 22.7654 25.764 24.7692L27.1353 26.2251C28.8638 24.5971 31.1518 23.7705 33.4852 23.9195L33.6126 21.9235ZM25.7029 24.8321C23.757 27.017 22.7691 29.9105 22.947 32.8581L24.9433 32.7376C24.7969 30.3115 25.6108 27.9426 27.1965 26.1622L25.7029 24.8321ZM22.9452 32.7978V50.1045H24.9452V32.7978H22.9452ZM22.947 50.0443C22.7691 52.9918 23.757 55.8853 25.7029 58.0703L27.1965 56.7401C25.6108 54.9597 24.7969 52.5908 24.9433 50.1648L22.947 50.0443ZM25.764 58.1332C27.8915 60.1369 30.7206 61.1634 33.6126 60.9788L33.4852 58.9829C31.1518 59.1318 28.8638 58.3053 27.1353 56.6773L25.764 58.1332ZM33.5489 60.9808H50.3779V58.9808H33.5489V60.9808ZM50.3137 60.9788C53.1872 61.1635 56.0347 60.1374 58.1627 58.1332L56.7914 56.6773C55.0634 58.3048 52.7577 59.1317 50.442 58.9829L50.3137 60.9788ZM58.2272 58.0665C60.1489 55.8864 61.1579 52.9961 60.9797 50.0443L58.9834 50.1648C59.1295 52.5865 58.3006 54.9586 56.7269 56.7439L58.2272 58.0665ZM60.9816 50.1045V32.7978H58.9816V50.1045H60.9816ZM60.9801 32.8514C61.138 29.9085 60.1518 27.0171 58.2058 24.8321L56.7122 26.1622C58.2978 27.9425 59.1134 30.3135 58.983 32.7443L60.9801 32.8514Z",
    fill: "url(#paint1_linear_33_191)",
    mask: "url(#path-3-outside-1_33_191)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_33_191)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_33_191",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2507 37.9313L40.1245 50.4389C39.4938 51.0689 38.665 51.4209 37.8001 51.4209H33.5658C33.3316 51.4209 33.1154 51.3283 32.9532 51.1615C32.7911 50.9948 32.719 50.7724 32.719 50.5315L32.8271 46.14C32.8451 45.2691 33.1875 44.4538 33.7821 43.8423L42.3767 35.0037C42.5209 34.8554 42.7731 34.8554 42.9173 35.0037L45.9263 38.0796C46.1245 38.2834 46.4128 38.4131 46.7191 38.4131C47.3858 38.4131 47.9083 37.8572 47.9083 37.1902C47.9083 36.8566 47.7822 36.5602 47.584 36.3378C47.53 36.2637 44.6651 33.336 44.6651 33.336C44.4849 33.1507 44.4849 32.8357 44.6651 32.6504L45.8723 31.3904C46.9894 30.2415 48.7912 30.2415 49.9084 31.3904L52.2507 33.7992C53.3498 34.9295 53.3498 36.7825 52.2507 37.9313Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.2507 37.9313L40.1245 50.4389C39.4938 51.0689 38.665 51.4209 37.8001 51.4209H33.5658C33.3316 51.4209 33.1154 51.3283 32.9532 51.1615C32.7911 50.9948 32.719 50.7724 32.719 50.5315L32.8271 46.14C32.8451 45.2691 33.1875 44.4538 33.7821 43.8423L42.3767 35.0037C42.5209 34.8554 42.7731 34.8554 42.9173 35.0037L45.9263 38.0796C46.1245 38.2834 46.4128 38.4131 46.7191 38.4131C47.3858 38.4131 47.9083 37.8572 47.9083 37.1902C47.9083 36.8566 47.7822 36.5602 47.584 36.3378C47.53 36.2637 44.6651 33.336 44.6651 33.336C44.4849 33.1507 44.4849 32.8357 44.6651 32.6504L45.8723 31.3904C46.9894 30.2415 48.7912 30.2415 49.9084 31.3904L52.2507 33.7992C53.3498 34.9295 53.3498 36.7825 52.2507 37.9313Z",
    fill: "url(#paint2_linear_33_191)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1245 50.4389L40.2658 50.5804L40.2681 50.5781L40.1245 50.4389ZM32.719 50.5315L32.519 50.5266V50.5315H32.719ZM32.8271 46.14L33.027 46.1449L33.0271 46.1441L32.8271 46.14ZM33.7821 43.8423L33.9255 43.9817L33.7821 43.8423ZM42.3767 35.0037L42.2334 34.8642L42.3767 35.0037ZM42.9173 35.0037L42.7739 35.1431L42.7743 35.1435L42.9173 35.0037ZM45.9263 38.0796L46.0697 37.9402L46.0693 37.9397L45.9263 38.0796ZM47.584 36.3378L47.4224 36.4556L47.4282 36.4636L47.4347 36.4709L47.584 36.3378ZM44.6651 33.336L44.5217 33.4754L44.5221 33.4759L44.6651 33.336ZM44.6651 32.6504L44.8084 32.7898L44.8095 32.7888L44.6651 32.6504ZM45.8723 31.3904L45.7289 31.2509L45.7279 31.252L45.8723 31.3904ZM49.9084 31.3904L49.765 31.5298L49.9084 31.3904ZM52.2507 33.7992L52.3941 33.6598L52.2507 33.7992ZM52.1071 37.7921L39.9809 50.2996L40.2681 50.5781L52.3943 38.0706L52.1071 37.7921ZM39.9831 50.2974C39.3884 50.8915 38.6098 51.2209 37.8001 51.2209V51.6209C38.7202 51.6209 39.5993 51.2462 40.2658 50.5804L39.9831 50.2974ZM37.8001 51.2209H33.5658V51.6209H37.8001V51.2209ZM33.5658 51.2209C33.3862 51.2209 33.2215 51.1505 33.0966 51.0221L32.8098 51.3009C33.0093 51.506 33.277 51.6209 33.5658 51.6209V51.2209ZM33.0966 51.0221C32.9785 50.9006 32.919 50.7326 32.919 50.5315H32.519C32.519 50.8122 32.6036 51.0889 32.8098 51.3009L33.0966 51.0221ZM32.9189 50.5364L33.027 46.1449L32.6272 46.1351L32.5191 50.5266L32.9189 50.5364ZM33.0271 46.1441C33.044 45.3235 33.3664 44.5567 33.9255 43.9817L33.6387 43.7029C33.0085 44.3509 32.6462 45.2147 32.6271 46.1358L33.0271 46.1441ZM33.9255 43.9817L42.5201 35.1431L42.2334 34.8642L33.6387 43.7029L33.9255 43.9817ZM42.5201 35.1431C42.5857 35.0756 42.7083 35.0756 42.7739 35.1431L43.0607 34.8642C42.838 34.6352 42.456 34.6352 42.2334 34.8642L42.5201 35.1431ZM42.7743 35.1435L45.7834 38.2194L46.0693 37.9397L43.0603 34.8638L42.7743 35.1435ZM45.7829 38.219C46.0178 38.4605 46.3573 38.6131 46.7191 38.6131V38.2131C46.4683 38.2131 46.2313 38.1063 46.0697 37.9402L45.7829 38.219ZM46.7191 38.6131C47.5034 38.6131 48.1083 37.9604 48.1083 37.1902H47.7083C47.7083 37.7541 47.2682 38.2131 46.7191 38.2131V38.6131ZM48.1083 37.1902C48.1083 36.8048 47.9623 36.4616 47.7333 36.2047L47.4347 36.4709C47.6021 36.6587 47.7083 36.9084 47.7083 37.1902H48.1083ZM47.7456 36.2199C47.7328 36.2024 47.7064 36.1744 47.6881 36.155C47.6635 36.1287 47.6294 36.0929 47.5875 36.0492C47.5035 35.9616 47.3869 35.8408 47.2487 35.6983C46.9723 35.4132 46.609 35.0401 46.2474 34.6694C45.8859 34.2988 45.526 33.9305 45.2566 33.6548C45.1218 33.517 45.0097 33.4023 44.9312 33.3221C44.892 33.282 44.8612 33.2505 44.8402 33.229C44.8297 33.2183 44.8217 33.2101 44.8162 33.2045C44.8135 33.2017 44.8115 33.1996 44.8101 33.1982C44.8094 33.1975 44.8089 33.197 44.8085 33.1966C44.8084 33.1965 44.8082 33.1963 44.8081 33.1962C44.8081 33.1962 44.8081 33.1962 44.808 33.1961C44.808 33.1961 44.808 33.1961 44.6651 33.336C44.5221 33.4759 44.5221 33.4759 44.5221 33.4759C44.5222 33.4759 44.5222 33.476 44.5222 33.476C44.5223 33.4761 44.5225 33.4762 44.5226 33.4764C44.523 33.4768 44.5235 33.4773 44.5242 33.478C44.5256 33.4794 44.5276 33.4815 44.5303 33.4843C44.5357 33.4898 44.5438 33.498 44.5543 33.5088C44.5753 33.5302 44.6061 33.5617 44.6453 33.6018C44.7237 33.682 44.8358 33.7966 44.9705 33.9344C45.2399 34.21 45.5997 34.5782 45.9611 34.9488C46.3225 35.3193 46.6856 35.692 46.9615 35.9767C47.0995 36.1191 47.2156 36.2392 47.2987 36.3259C47.3403 36.3693 47.3733 36.404 47.3965 36.4288C47.4262 36.4603 47.4284 36.4639 47.4224 36.4556L47.7456 36.2199ZM44.8084 33.1966C44.7037 33.0889 44.7037 32.8975 44.8084 32.7898L44.5217 32.511C44.266 32.7739 44.266 33.2125 44.5217 33.4754L44.8084 33.1966ZM44.8095 32.7888L46.0167 31.5287L45.7279 31.252L44.5206 32.512L44.8095 32.7888ZM46.0157 31.5298C47.0543 30.4617 48.7264 30.4617 49.765 31.5298L50.0517 31.2509C48.8561 30.0213 46.9246 30.0213 45.7289 31.2509L46.0157 31.5298ZM49.765 31.5298L52.1073 33.9387L52.3941 33.6598L50.0517 31.2509L49.765 31.5298ZM52.1073 33.9387C53.1304 34.9907 53.1319 36.7209 52.1062 37.7931L52.3952 38.0696C53.5677 36.8441 53.5693 34.8684 52.3941 33.6598L52.1073 33.9387Z",
    fill: "url(#paint3_linear_33_191)",
    fillOpacity: 0.5,
    mask: "url(#path-5-inside-2_33_191)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_33_191",
    x: 0.418213,
    y: 0.861176,
    width: 64.1924,
    height: 64.3728,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "effect1_foregroundBlur_33_191"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_33_191",
    x: -1.07349,
    y: -2.09766,
    width: 86.0735,
    height: 87.0977,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_33_191"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_33_191",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_33_191",
    x: 17.719,
    y: 15.5287,
    width: 50.356,
    height: 50.8922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_33_191"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.454902 0 0 0 0 0.870588 0 0 0 0 0.376471 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_33_191",
    result: "effect2_dropShadow_33_191"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_33_191",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_191",
    x1: 44.0567,
    y1: 12,
    x2: 27.817,
    y2: 45.0605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BF763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26AB5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33_191",
    x1: 29.6688,
    y1: 27.2243,
    x2: 53.4642,
    y2: 55.8818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33_191",
    x1: 51.6318,
    y1: 34.3015,
    x2: 28.9559,
    y2: 35.0218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_33_191",
    x1: 34.9118,
    y1: 37.5371,
    x2: 52.1969,
    y2: 37.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.22ba6776bcc702e6eb756e6930616137.svg";
export { ForwardRef as ReactComponent };